module.exports = __webpack_public_path__ + "static/l_large-e24e312403a3828b0308b2b1994bc220.jpg";